import { StyledIconVisa } from './IconVisa.styled';

const IconVisa = () => {
  return <StyledIconVisa />;
};

export default IconVisa;
